module.exports = __webpack_public_path__ + "5e6f704945e64f57534c95490efd4637.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/touxiang.png
// module id = 1269
// module chunks = 61